import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY, USER_SUCCESS_KEY} from "shared/const/localstorage";
import {logoutActions} from "../../slice/logoutSlice";
import {accountUserActions} from "app/accountLoginSlice";
import OneSignal from "react-onesignal";


export const logoutByUser = createAsyncThunk(
    'logout/logoutByUser',
    async (_, thunkAPI) => {

        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const {token, expires} = JSON.parse(authToken);

            // Проверка срока действия токена
            const currentTimestamp = Math.floor(Date.now() / 1000);
            if (expires && currentTimestamp > expires) {
                thunkAPI.dispatch(logoutActions.logout());
                return;
            }


            const response = await axios.get('/api/logout', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then(res => {
                if (res.data.success) {
                    localStorage.removeItem(USER_SUCCESS_KEY);
                    thunkAPI.dispatch(logoutActions.logout());
                    thunkAPI.dispatch(accountUserActions.accountUser());
                    OneSignal.logout();
                }
            });
            return;
        } catch (e) {
            return thunkAPI.rejectWithValue('error');
        }
    }
);
